import React from "react"
import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group"
import {ColorPalette} from "../../../../../color-coding/color-coding";

// const debug = "FieldExpenseApprovalStatus_GListGroupStandard"
const debug = false

export default function FieldExpenseApprovalStatus_GListGroupStandard(props:FieldGlistGroupProps) {

    const option = props.field._getOption(props.data.value)

    const groupColor:any = _.get(option, 'color', null);
    const groupName = _.get(option, 'label', props.field.noValueOptionLabel);

    const classes: string       = Classes("group-cards", {
        'colored-background': !!groupColor,
    })

    debug && console.log(debug, 'render', groupColor, option)

    const styles = {
        backgroundColor: gd.skin.colors.mainColor({
            colorNumber: groupColor,
            corePalette: ColorPalette.STATUS
        })
    }

    return (
        <div className={classes} style={styles}>
            <div className="text">{groupName}</div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className="top-corner" style={styles}/>
                </div>}
        </div>
    )
}
